module.exports = __webpack_public_path__ + "img/dark.10bb186d.webp";